import React from 'react';
import QRCode from 'qrcode.react';
import { saveAs } from 'file-saver';
 
const QrGenerate = () => {
  const url = `${window.location.origin}/client-information`;
 
  const handleDownload = () => {
    const canvas = document.getElementById('qr-code-canvas');
    canvas.toBlob((blob) => {
      saveAs(blob, 'qrcode.png');
    });
  };
 
  return (
    <div className="flex flex-col items-center justify-center h-screen p-4 bg-gray-50">
      <div className="w-full max-w-md bg-white shadow-lg rounded-lg p-6 text-center">
        <h2 className="text-2xl font-semibold mb-4">Scan this QR Code</h2>
        <QRCode
          id="qr-code-canvas"
          value={url}
          size={256}
          className="mx-auto mb-4 border border-gray-200 p-2 rounded-lg"
        />
        <p className="text-gray-600 mb-4">This QR code will direct you to our client information page.</p>
        <button
          onClick={handleDownload}
          className="bg-blue-500 text-white py-2 px-4 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
        >
          Download QR Code
        </button>
      </div>
    </div>
  );
};
 
export default QrGenerate;
 